<template>
  <m-dropdown
    v-model:value="showFilterOptions"
    class="list-filter"
    :title="$t('listSorter.title')"
    :disabled="disabled"
    block
  >
    <m-btn
      class="_btn"
      small
      hide-border
      icon="funnel"
      fab
      :disabled="disabled"
      :color="color"
      :light="!hasValue"
      @click.stop="handleFilterClick"
    >
      <div
        v-if="hasUnsavedChanges"
        class="_dot"
      >
        <change-indicator />
      </div>
    </m-btn>
    <template #overlay>
      <m-card no-padding>
        <filter-options
          :filter-options="scopeItems"
          @add-quick-filter="addQuickFilter"
          @add-advanced-filter="addAdvancedFilter"
        />
      </m-card>
    </template>
  </m-dropdown>
</template>

<script setup>
import ChangeIndicator from '@/components/list/ChangeIndicator.vue';
import FilterOptions from '@/components/filter/FilterOptions.vue';
import useScopeItems from '@/composables/filter/scope-items';
import { QUICK_FILTER_TYPE_SCOPE_ITEM, VIEW_EVENT_BUS } from '@/lib/constants';
import { computed, inject, ref } from 'vue';

const props = defineProps({
  filterProps: {
    type: Array,
    default: () => [],
  },
  hasValue: {
    type: Boolean,
    default: false,
  },
  hasUnsavedChanges: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const eventBus = inject(VIEW_EVENT_BUS);

const showFilterOptions = ref(false);

const color = computed(() => {
  if (props.hasValue) {
    return 'primary';
  }
  return '';
});

const handleFilterClick = () => {
  if (props.hasValue) {
    eventBus.$emit('toggle-view-toolbar', { toolbarAction: 'filter' });
    return;
  }
  showFilterOptions.value = true;
};

const { scopeItems } = useScopeItems(
  computed(() => props.filterProps.filter((p) => !p.property.noFilter)),
  false,
  props.multiModel,
);

const addQuickFilter = (scopeItem) => {
  eventBus.$emit('show-view-toolbar');
  eventBus.$emit('applyFilter', scopeItem, QUICK_FILTER_TYPE_SCOPE_ITEM);
  showFilterOptions.value = false;
};
const addAdvancedFilter = (scopeItem) => {
  eventBus.$emit('show-view-toolbar');
  eventBus.$emit('applyAdvancedFilter', scopeItem);
  showFilterOptions.value = false;
};
</script>

<style scoped lang="scss">
.list-filter {
  ._btn {
    position: relative;

    ._dot {
      position: absolute;
      right: .3rem;
      top: .3rem;
    }
  }
}
</style>
